<template>
  <div class="custom_container">
    <div class="custom_box" v-if="isshow">
      <h3>河北安诚保险电子保函支付</h3>
      <div class="form_box">
        <el-form ref="form" :model="form" label-width="180px">
          <div class="title">订单信息</div>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="订单号：">{{ formLink.orderNum }}</el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="订单金额：">￥{{ formLink.orderFee }}</el-form-item>
            </el-col>
          </el-row>
          <div class="title">收款账号</div>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="收款方开户行：">
                <el-input v-model="form.collect_company" placeholder="请输入内容" disabled />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="收款方户名：">
                <el-input v-model="form.collect_name" placeholder="请输入内容" disabled />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="收款方账号：">
                <el-input v-model="form.collect_num" placeholder="请输入内容" disabled />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-button style="float: right;" type="primary" @click="copyTemplate">复制收款方账号</el-button>
            </el-col>
          </el-row>
        </el-form>
        <el-form ref="formLink" :model="formLink" label-width="180px" :rules="rules">
          <div class="title">保函信息</div>
          <el-row>
            <el-col :span="12">
              <el-form-item label="保函有效期（天）:" prop="bidValidity">
                <el-input v-model="formLink.bidValidity" disabled placeholder="请输入投标有效期，最长不超过180" @input="handInput"
                  maxlength="10" />
              </el-form-item>
            </el-col>
          </el-row>
          <div class="title">付款信息 <span class="pay_warning">请使用企业基本户进行支付</span></div>
          <el-row :gutter="20">
            <!-- <el-col :span="12">
              <el-form-item label="企业基本户开户银行：" prop="bankName">
                <el-input v-model="formLink.bankName" placeholder="请输入付款方支付银行名称" maxlength="25" show-word-limit />
              </el-form-item>
            </el-col> -->
            <el-col :span="12">
              <el-form-item label="银行基本户账号：" prop="accountNum">
                <el-input v-model="formLink.accountNum" placeholder="请输入支付保费的银行基本户账号" maxlength="50" show-word-limit />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="银行基本户名称：" prop="accountName">
                <el-input v-model="formLink.accountName" placeholder="请输入支付保费的银行基本户名称" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <!-- <el-col :span="12">
              <el-form-item label="企业银行基本账户：" prop="accountName">
                <el-input v-model="formLink.accountName" placeholder="请输入企业银行基本账户" />
              </el-form-item>
            </el-col> -->
            <!-- <el-col :span="12">
              <el-form-item label="支付流水号：" prop="bankSerial">
                <el-input v-model="formLink.bankSerial" placeholder="请输入付款后的银行支付流水号" />
              </el-form-item>
            </el-col> -->
          </el-row>
          <!-- <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="经办人名称" prop="name">
                <el-input v-model="formLink.name" placeholder="请输入内容" maxlength="4" show-word-limit />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="经办人联系方式" prop="phone">
                <el-input v-model="formLink.phone" placeholder="请输入内容" />
              </el-form-item>
            </el-col>
          </el-row> -->
          <div class="title">上传支付凭证</div>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="支付凭证：" required>
                <el-upload class="upload-demo" action="/api/AttestationController/uploadComFile"
                  :on-success="successInfo" :file-list="fileList" :on-remove="onremove" :before-upload="befor"
                  :on-change="handleChange" :data="data" accept=".jpeg,.jpg,.png" name="enterpriseInfoFile">
                  <el-button icon="el-icon-upload" size="small" type="primary">点击上传</el-button>
                  <div slot="tip" class="el-upload__tip">
                    支持格式：.jpg .jpeg .png ，单个文件不能超过5MB;<p style="color: red;line-height: 10px;">
                      文件名称请勿包含特殊字符，例如“，`。.~*&()^@#$”</p>
                  </div>
                  <!-- <div slot="tip" class="el-upload__tip" style="color:red">
                    本订单由河北信投担保和永信正德担保联合承保
                  </div> -->
                </el-upload>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <div class="right_text">
                <img src="../../assets/payq.png" style="min-width: 50px;min-height: 50px;" alt="">
                <p>
                  本产品支持在线【核保、投保、退保、报案、保单查询】等服务，暂未完全实现在线批改、理赔，您可通过官方客服热线、安诚财产保险股份有限公司微信公众号等自助渠道进行办理或咨询业务流程。也可以扫描右侧二维码联系保函平台在线客服。
                </p>
              </div>
            </el-col>
          </el-row>
        </el-form>
        <div class="finish_bth">
          <el-button type="primary" @click="finishPay">完成支付</el-button>
        </div>
      </div>
    </div>
    <div class="customer">
      <div class="customer-logo ">
        <img src="../../assets/lo.png" alt="">
      </div>
      <div class="blue-sli" />
      <div class="phone">
        <div class="phone-img">
          <img src="../../assets/微信图片_20231101083937.png" alt="">
        </div>
        <p>客服热线</p>
      </div>
      <div class="phone-text">400-183-1833</div>
      <div class="blue-sli" />
      <div class="phone">
        <div class="phone-img">
          <img src="../../assets/ke.png" alt="">
        </div>
        <p>在线客服</p>
      </div>
      <div class="customer-code">
        <img src="../../assets/erCode.png" alt="">
      </div>
      <div class="customer-text">
        <p>发票申请、保函问题</p>
        <p>请联系客服</p>
      </div>
    </div>
    <el-dialog
      title="提示"
      :visible.sync="istit"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      top="18vh"
      width="800px">
      <p style="padding:30px 0  50px;font-size: 20px;">
系统升级于2025年6月30日-2025年7月1日进行升级维护，7.2日可正常出函，请添加客服微信，维护完毕后将统一发送通知，感谢您的支持与理解
      </p>
    </el-dialog>
    
  </div>
</template>

<script>
// import clip from '@/utils/clipboard'
import { goAnPay } from '../../apis/project/index'
import BigNumber from 'bignumber.js'

export default {
  name: 'Pay',
  data() {
    const phoneRules = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入经办人联系方式"));
      } else {
        const reg =
          /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error("请输入正确的经办人联系方式"));
        }
      }
    };
    return {

      type: null,
      action: '',
      data: {},
      userId: '',
      orderFee: '',
      form: {
        collect_company: '交通银行股份有限公司石家庄熙园支行',
        collect_name: '安诚财产保险股份有限公司河北分公司',
        collect_num: '131720000012017005295'
      },
      rules: {
        name: [
          { required: true, message: '请输入经办人名称', trigger: 'blur' }
        ],
        phone: [{ required: true, validator: phoneRules, trigger: "blur" }],
        bankSerial: [
          { required: true, message: '请输入支付流水号', trigger: 'blur' }
        ],
        bankName: [
          { required: true, message: '请输入企业基本户开户银行', trigger: 'blur' }
        ],
        accountNum: [
          { required: true, message: '请输入支付保费的银行基本户账号', trigger: 'blur' }
        ],
        // absolutePath: [
        //   { required: true, message: '请选择上传支付凭证', trigger: 'change' }
        // ],
        bidValidity: [
          { required: true, message: '请输入投标有效期，最长不超过180', trigger: 'blur' }
        ],
        accountName: [
          { required: true, message: '请输入支付保费的银行基本户名称', trigger: 'blur' }
        ],
      },
      formLink: {
        // name: null,
        // phone: null,
        bankSerial: null,
        orderId: null,
        userId: null,
        bidValidity: 180,
        accountName: null,
        accountNum: null,
      },
      company_kh: '',
      company_num: '',
      fileList: [], // 协议上传
      isshow: true,
      checked1: false,//是否点击了阅读
      istit:false,
    }
  },
  created() {
    this.formLink.orderId = this.$route.query.orderId
    this.formLink.userId = this.$route.query.userId
    this.formLink.orderFee = this.$route.query.orderFee
    this.formLink.comCode = this.$route.query.guarantorId
    this.formLink.orderNum = this.$route.query.orderNum
    this.formLink.accountNum = this.$route.query.accountNum ? this.$route.query.accountNum : ''
    this.formLink.accountName = this.$route.query.accountName ? this.$route.query.accountName : ''
    this.data = {
      userId: this.formLink.userId,
      isRecognition: "N",
      type: 4,
    }
    // this.getComputedStyle()
  },
  methods: {
    getComputedStyle() {
      // 交投信投计算方式：千分之五，最低200
      let newPremium = Number(BigNumber(this.formLink.orderFee).times(0.005).toNumber().toFixed(2))
      // 如果小于200元按二百元计算
      if (newPremium < 200) {
        newPremium = 200
      }
      // 如果前端计算的和后端计算的一样则显示页面
      if (newPremium == this.formLink.orderFee) {
        this.isshow = true
      } else {
        this.$alert(`<strong><p>为了您出函的效率，请您先联系客服：15383893908</p>订单号：${this.formLink.orderNum}</strong>`, '提示', {
          showClose: false,
          dangerouslyUseHTMLString: true,
          callback: action => {
            window.open('', '_self')
            window.close()
            setTimeout(() => {
              window.location.href = 'https://www.haneton.com'
            }, 4000)
          }
        })
      }
    },
    successInfo(res) {
      if (res.status > 0) {
        this.$message({
          message: '上传成功',
          type: 'success'
        })
        this.formLink.absolutePath = res.data.absolutePath;
      } else {
        this.$message.error(res.statusInfo)
      }
    },
    handleCopy(text, event) {
      clip(text, event)
    },
    finishPay() {
      this.$refs['formLink'].validate(valid => {
        if (valid) {
          if (this.formLink.absolutePath) {
            goAnPay(this.formLink).then((res) => {
              if (res.data.status == 1) {
                this.$alert('订单支付完成', '消息', {
                  confirmButtonText: '确定',
                  showClose: false,
                  callback: action => {
                    window.open("", "_self");
                    window.close();
                    setTimeout(() => {
                      window.location.href = "https://www.haneton.com";
                    }, 4000);
                  }
                })
              }
              else {
                this.$message({
                  duration: 5000,
                  message: res.data.statusInfo,
                  type: 'error'
                });
              }
            })
          }
          else {
            this.$message({
              message: '请上传支付凭证',
              type: 'warning'
            })
          }
        }
      })
    },
    copyTemplate() {
      let str = `订单号：${this.formLink.orderNum}\n订单金额：${this.formLink.orderFee}\n收款方开户行：${this.form.collect_company}\n收款方户名：${this.form.collect_name}\n收款方账号：${this.form.collect_num}`
      this.copyToClipboard(str
      ); // 需要复制的文本内容
      this.$message.success("复制成功");
    },
    // 点击复制到剪贴板函数
    copyToClipboard(content) {
      if (window.clipboardData) {
        window.clipboardData.setData("text", content);
      } else {
        (function (content) {
          document.oncopy = function (e) {
            e.clipboardData.setData("text", content);
            e.preventDefault();
            document.oncopy = null;
          };
        })(content);
        document.execCommand("Copy");
      }
    },
    onremove(eile) {
      this.formLink.absolutePath = ''
    },
    handleChange(file, fileList) {
      this.fileList = [fileList[fileList.length - 1]]
    },
    befor(file, fileList) {
      console.log(file);

      //异步上传判断文件类型
      let jpg = ['image/png', 'image/jpeg']
      if (jpg.indexOf(file.type) == -1) {
        this.fileList = []
        this.$message.error("上传文件只能是JPG、PNG、JPEG格式!");
        return false
      }
      const is5M = file.size / 1024 / 1024 < 5;
      //限制文件上传大小
      if (!is5M) {
        this.fileList = []
        this.$message.error("上传文件大小不能超过5MB!");
        return false
      }
    },
    handInput() {
      this.formLink.bidValidity = this.formLink.bidValidity.replace(/[^\d]/g, '')
      if (this.formLink.bidValidity > 180) {
        this.formLink.bidValidity = 180
      }
    },
  }
}
</script>

<style lang="less" scoped>
.custom_container {
  font-size: 16PX;

  .custom_box {
    width: 70%;
    // border: 1px solid #999999;
    box-shadow: 0 2PX 12PX 0 rgba(0, 0, 0, .1);
    margin: 40PX auto;
    padding: 30PX 50PX;

    h3 {
      text-align: center;
      padding: 20PX 0 15PX 0;
    }

    .pay_warning {
      color: #ff0000;
      font-weight: normal;
      margin-left: 50PX;
    }

    .pay_info {
      display: flex;
      font-size: 14PX;
      color: #606266;
      margin-bottom: 22PX;

      >div:nth-child(2) {
        margin-left: 270PX;
      }
    }

    .finish_bth {
      text-align: center;
      margin: 30PX 0;
    }
  }
}

.customer {
  position: fixed;
  right: 3%;
  bottom: 20%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .blue-sli {
    height: 1PX;
    width: 160PX;
    margin: 3PX 0 15PX 0;
    background-color: #1196db;
  }

  .phone {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    .phone-img {
      width: 50PX;
      height: 50PX;
      margin-right: 15PX;

      img {
        width: 100%;
      }
    }

    p {
      font-weight: bold;
    }
  }

  .phone-text {
    // margin-top: PX;
    font-size: 22PX;
    ;
    font-weight: bold;
  }

  .customer-logo {
    width: 160PX;
    height: 100%;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .customer-code {
    width: 160PX;
    height: 160PX;
    margin-top: 5PX;

    img {
      width: 100%;
    }
  }

  .customer-text {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    p {
      margin-top: 5PX;
      font-weight: bold;
    }
  }
}

::v-deep .el-dialog__title {
  border-left: 5PX solid #3b7df9;
  padding-left: 10PX;
  font-weight: bold;
}

::v-deep .el-dialog__footer {
  text-align: center;
}

::v-deep .el-upload__tip {
  white-space: nowrap;
}
.right_text{
  background-color: #f9f9f9;
  padding: 15PX;
  color: #777777;
  font-weight: bold;
  display: flex;
  font-size: 14PX;
  letter-spacing: 1.3PX;
  img{
    margin-right: 15PX;
    width: 55PX;
    height: 55PX;
  }
}
</style>
